import React from 'react';
import { PersonData } from '../../type/Types';

export type PersonDataType = Pick<PersonData, 'id' | 'degreeBefore' | 'degreeAfter' | 'firstName' | 'lastName'>;

export interface PersonNameLabelProps {
  person: {
    personData: PersonDataType;
  };
  showDegrees?: boolean;
}

function formatPersonNameWithDegrees(personData: PersonDataType) {
  const names = formatPersonNameWithoutDegrees(personData);

  const degreeBeforePrefix = personData.degreeBefore ? personData.degreeBefore + ' ' : '';
  const degreeAfterSuffix = personData.degreeAfter ? ', ' + personData.degreeAfter : '';

  return `${degreeBeforePrefix}${names}${degreeAfterSuffix}`;
}

function formatPersonNameWithoutDegrees(personData: PersonDataType) {
  return `${personData.lastName} ${personData.firstName}`;
}

export default function PersonNameLabel({ person, showDegrees = true }: PersonNameLabelProps) {
  if (!showDegrees) {
    return <span>{formatPersonNameWithoutDegrees(person.personData)}</span>;
  }

  return <span>{formatPersonNameWithDegrees(person.personData)}</span>;
}
